import React from "react";

// // // //

export function DefaultForm() {
    return (
        <iframe
            className="w-full h-192"
            src="https://forms.default.com/16925"
        />
    );
}
